import { render } from "./KnowledgeBaseUI.vue?vue&type=template&id=33045bc4&scoped=true"
import script from "./KnowledgeBaseUI.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseUI.vue?vue&type=script&lang=js"

import "./KnowledgeBaseUI.vue?vue&type=style&index=0&id=33045bc4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33045bc4"]])

export default __exports__